import * as actionTypes from "./actionTypes";

const initialState = {
  refunds: [],
  loading: false,
  error: null,
  approving: false,
  rejecting: false,
  markingRefunded: false,
};

const refundReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch refunds
    case actionTypes.FETCH_REFUNDS_REQUEST:
      return { ...state, loading: true, error: null };
    case actionTypes.FETCH_REFUNDS_SUCCESS:
      return { ...state, refunds: action.payload || [], loading: false };
    case actionTypes.FETCH_REFUNDS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Approve refund
    case actionTypes.APPROVE_REFUND_REQUEST:
      return {
        ...state,
        approving: true,
        error: null,
      };
    case actionTypes.APPROVE_REFUND_SUCCESS:
      return {
        ...state,
        refunds: state.refunds.map((r) =>
          r.id === action.payload.id ? action.payload : r
        ),
        approving: false,
      };
    case actionTypes.APPROVE_REFUND_FAILURE:
      return {
        ...state,
        approving: false,
        error: action.payload,
      };

    // Reject refund
    case actionTypes.REJECT_REFUND_REQUEST:
      return {
        ...state,
        rejecting: true,
        error: null,
      };
    case actionTypes.REJECT_REFUND_SUCCESS:
      return {
        ...state,
        refunds: state.refunds.map((r) =>
          r.id === action.payload.id ? action.payload : r
        ),
        rejecting: false,
      };
    case actionTypes.REJECT_REFUND_FAILURE:
      return {
        ...state,
        rejecting: false,
        error: action.payload,
      };

    // Mark refund as refunded
    case actionTypes.MARK_REFUND_REFUNDED_REQUEST:
      return { ...state, markingRefunded: true, error: null };
    case actionTypes.MARK_REFUND_REFUNDED_SUCCESS:
      return {
        ...state,
        markingRefunded: false,
        refunds: state.refunds.map((r) =>
          r.id === action.payload.id ? action.payload : r
        ),
      };
    case actionTypes.MARK_REFUND_REFUNDED_FAILURE:
      return { ...state, markingRefunded: false, error: action.payload };

    // Generate refund from flagged invoice
    case actionTypes.GENERATE_REFUND_FROM_FLAGGED_INVOICE_REQUEST:
      return { ...state, loading: true, error: null };
    case actionTypes.GENERATE_REFUND_FROM_FLAGGED_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        refunds: [...state.refunds, action.payload],
      };
    case actionTypes.GENERATE_REFUND_FROM_FLAGGED_INVOICE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default refundReducer;
